import React from 'react';
import { SignIn as SignInComponent } from '@thd-olt-component-react/sign-in';
import { Hydrator } from '@thd-olt-component-react/hydrator';
import { QueryProvider } from '@thd-nucleus/data-sources';

import classnames from 'classnames/bind';
import componentStyles from './components.module.scss';

const styles = classnames.bind(componentStyles);

export function CustomRenderedSignIn({
  SCROLL_BUFFER,
  HOMEPAGE_DELAY_STANDARD,
  PLACEHOLDER,
}) {
  return function SignIn() {
    return (
      <QueryProvider cachekey="sign-in">
        <Hydrator
          id="signIn-php-hydrator"
          className={styles('u-height-100')}
          scrollBuffer={SCROLL_BUFFER}
          delay={HOMEPAGE_DELAY_STANDARD}
          placeholder={PLACEHOLDER}
        >
          <SignInComponent />
        </Hydrator>
      </QueryProvider>
    );
  };
}
